export { default as AdLocation } from './AdLocation';



// WEBPACK FOOTER //
// ./src/components/AdCard/AdSummary/AdLocation/index.ts